module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normal-width": "90vw",
      "width": "960px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stopper($event)
      }
    }
  }, [_c('div', {
    class: 'map-background map-background--' + _vm.SITE_CONFIG.site + ' type--' + _vm.params.type,
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d64ef208"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MapModalkungsberget.vue
// module id = 1028
// module chunks = 0